import { makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { ReactComponent as CaretLeftDisabledSvg } from '../../../../assets/know_each_other/caret_left_disabled.svg';
import { ReactComponent as CaretLeftSvg } from '../../../../assets/know_each_other/caret_left.svg';
import { ReactComponent as CaretRightDisabledSvg } from '../../../../assets/know_each_other/caret_right_disabled.svg';
import { ReactComponent as CaretRightSvg } from '../../../../assets/know_each_other/caret_right.svg';
import { spacings } from '../../../../theme';
import { ButtonColor } from '../../../shared/primitives/PlexButton';
import { PlexIconButton } from '../../../shared/primitives/PlexIconButton';

interface Props {
  pageIndex: number;
  pagesCount: number;
  onChangePage: (newPageIndex: number) => void;
}

export const KnowEachOtherCarouselSwitch = (props: Props): React.ReactElement => {
  const { pageIndex, pagesCount, onChangePage } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {pageIndex === 0 ? (
        <PlexIconButton
          disabled
          className={classes.button}
          iconView={<CaretLeftDisabledSvg className={classes.icon} />}
          color={ButtonColor.TransparentGray}
          tooltip={'No more pages'}
          tooltipPlacement={'top'}
        />
      ) : (
        <PlexIconButton
          className={classes.button}
          iconView={<CaretLeftSvg className={classes.icon} />}
          onClick={(): void => {
            onChangePage(pageIndex - 1);
          }}
          color={ButtonColor.TransparentBlue}
        />
      )}
      {pageIndex === pagesCount - 1 ? (
        <PlexIconButton
          disabled
          className={classNames(classes.button, classes.caretRight)}
          iconView={<CaretRightDisabledSvg className={classes.icon} />}
          color={ButtonColor.TransparentGray}
          tooltip={'No more pages'}
          tooltipPlacement={'top'}
        />
      ) : (
        <PlexIconButton
          className={classNames(classes.button, classes.caretRight)}
          iconView={<CaretRightSvg className={classes.icon} />}
          onClick={(): void => {
            onChangePage(pageIndex + 1);
          }}
          color={ButtonColor.TransparentBlue}
        />
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  button: {
    padding: 0,
    width: 46,
    height: 46,
    backgroundColor: 'transparent',
    borderRadius: 24,
  },
  caretRight: {
    marginLeft: spacings.small,
  },
  icon: {
    width: '100%',
    height: '100%',
  },
}));
